import { z } from 'zod';

import { PaginationSchema } from '../../pagination.js';

export const ListPartyChangeLogQuerySchema = PaginationSchema;

export type ListPartyChangeLogQuery = z.infer<typeof ListPartyChangeLogQuerySchema>;

export const PartyChangeLogEntrySchema = z.object({
  id: z.uuid(),
  partyId: z.uuid(),
  changedAt: z.iso.datetime(),
  changedByUserId: z.uuid().nullable(),
  changedFields: z.array(z.string()),
  oldValues: z.record(z.string(), z.unknown()),
  newValues: z.record(z.string(), z.unknown()),
  reason: z.string().nullable(),
});

export type PartyChangeLogEntry = z.infer<typeof PartyChangeLogEntrySchema>;

export const ListPartyChangeLogResponseSchema = z.object({
  items: z.array(PartyChangeLogEntrySchema),
  pagination: z.object({
    cursor: z.string().nullable(),
    hasMore: z.boolean(),
  }),
});

export type ListPartyChangeLogResponse = z.infer<typeof ListPartyChangeLogResponseSchema>;
